export const CaretUpIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:caret-up-small">
			<path
				id="Vector"
				d="M12.5 7.50049L19.5 14.5005H5.5L12.5 7.50049Z"
				fill="#22082B"
			/>
		</g>
	</svg>
);
